import { createSlice } from "@reduxjs/toolkit";

const menuSlice = createSlice({
    name: "menus",
    initialState: {
        items: [],
    },
    reducers: {
        setMenus(state, action) {
            state.items = action.payload;
        }
    }
});

export const { setMenus } = menuSlice.actions;
export default menuSlice.reducer;
